import { Button } from '@yes.technology/react-toolkit'
import styled from 'styled-components'
import { FilterFieldLayout } from '../../types'

export const StyledField = styled.div`
  flex-grow: 1;
  width: 100%;
`

export const StyledFieldContainer = styled.div<{
  fieldLayout?: FilterFieldLayout
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 0.25rem;
  margin-top: 0.5rem;
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  box-sizing: border-box;
  flex-basis: 50%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-basis: ${({ fieldLayout }) => fieldLayout?.width || '50%'};
  }
  @media (min-width: 992px) {
    flex-basis: ${({ fieldLayout }) => fieldLayout?.width || '33.3333%'};
  }
  @media (min-width: 1200px) {
    flex-basis: ${({ fieldLayout }) => fieldLayout?.width || '25%'};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    flex-grow: 1;
    flex-basis: 100%;
  }
`

export const ActionSlotButton = styled(Button)`
  max-width: 40px;
  flex-shrink: 0;
  margin-top: auto;
`
